const SESSION_ID_QUERY_PARAM_NAME: string = 'sid';
const isTargetDemostack = (url: URL): boolean => {
  return url.hostname === document.location.hostname;
};
export const attachSession = (externalUrl: string): string => {
  const params = new URLSearchParams(document.location.search);
  const targetUrl = new URL(externalUrl);
  const inboundSessionId = params.get(SESSION_ID_QUERY_PARAM_NAME);
  if (inboundSessionId && isTargetDemostack(targetUrl)) {
    targetUrl.searchParams.append(
      SESSION_ID_QUERY_PARAM_NAME,
      inboundSessionId
    );
  }
  return targetUrl.href;
};
